import { FileTextOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { fetchArchivedFirstWeightEntrylist, resetFirstWeightEntryList, unArchiveFirstWeightEntry } from '../../slices/first-weight-entry';

export default function ArchiveFirstWeightEntry() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [orderBy, setOrderBy] = useState('')
  const [page, setPage] = useState(1);
  const { user: currentUser } = useSelector((state) => state?.auth);
  const [pagesize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState(localStorage.getItem('ArchiveFirstWeightEntry') || '');
  const [search, setSearch] = useState(localStorage.getItem('ArchiveFirstWeightEntry') || '');

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const dispatch = useDispatch();

  const { data = [], totalRecord = 0, status } = useSelector(state => state.firstWeightEntry || {});
  useEffect(() => {
    dispatch(resetFirstWeightEntryList());
    dispatch(fetchArchivedFirstWeightEntrylist({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
  }, [page, pagesize, search, orderBy]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('ArchiveFirstWeightEntry', value);
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable
    localStorage.removeItem('ArchiveFirstWeightEntry');
    dispatch(fetchArchivedFirstWeightEntrylist({ page: 1, pagesize }));
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRestore = (id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(unArchiveFirstWeightEntry(id))
      .unwrap()
      .then(() => {
        message.success('First Weight Entry Unarchived successfully!');
      })
      .catch((err) => {
        console.error('Delete Error:', err); // Debugging the error
        message.error(`Error: ${err || 'Failed to unarchive the first weight entry.'}`);
      });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "serial_no" && sortOrder === "ascend") sortingEnumKey = "serial_no";
  if (sortField === "serial_no" && sortOrder === "descend") sortingEnumKey = "-serial_no";

  if (sortField === "weight_for" && sortOrder === "ascend") sortingEnumKey = "weight_for";
  if (sortField === "weight_for" && sortOrder === "descend") sortingEnumKey = "-weight_for";

  if (sortField === "gross_wt" && sortOrder === "ascend") sortingEnumKey = "gross_wt";
  if (sortField === "gross_wt" && sortOrder === "descend") sortingEnumKey = "-gross_wt";

  if (sortField === "tare_wt" && sortOrder === "ascend") sortingEnumKey = "tare_wt";
  if (sortField === "tare_wt" && sortOrder === "descend") sortingEnumKey = "-tare_wt";

  if (sortField === "net_wt" && sortOrder === "ascend") sortingEnumKey = "net_wt";
  if (sortField === "net_wt" && sortOrder === "descend") sortingEnumKey = "-net_wt";

  if (sortField === "weight_automatic" && sortOrder === "ascend") sortingEnumKey = "weight_automatic";
  if (sortField === "weight_automatic" && sortOrder === "descend") sortingEnumKey = "-weight_automatic";

  if (sortField === "date_time" && sortOrder === "ascend") sortingEnumKey = "date_time";
  if (sortField === "date_time" && sortOrder === "descend") sortingEnumKey = "-date_time";

  if (sortField === "mound" && sortOrder === "ascend") sortingEnumKey = "mound";
  if (sortField === "mound" && sortOrder === "descend") sortingEnumKey = "-mound";

  if (sortField === "vehicle_no" && sortOrder === "ascend") sortingEnumKey = "vehicle_no";
  if (sortField === "vehicle_no" && sortOrder === "descend") sortingEnumKey = "-vehicle_no";

  if (sortField === "vehicle_type" && sortOrder === "ascend") sortingEnumKey = "vehicle_type";
  if (sortField === "vehicle_type" && sortOrder === "descend") sortingEnumKey = "-vehicle_type";

  if (sortField === "party_name" && sortOrder === "ascend") sortingEnumKey = "party_name";
  if (sortField === "party_name" && sortOrder === "descend") sortingEnumKey = "-party_name";

  if (sortField === "cash_party_name" && sortOrder === "ascend") sortingEnumKey = "cash_party_name";
  if (sortField === "cash_party_name" && sortOrder === "descend") sortingEnumKey = "-cash_party_name";

  if (sortField === "party_mobile_no" && sortOrder === "ascend") sortingEnumKey = "party_mobile_no";
  if (sortField === "party_mobile_no" && sortOrder === "descend") sortingEnumKey = "-party_mobile_no";

  if (sortField === "material" && sortOrder === "ascend") sortingEnumKey = "material";
  if (sortField === "material" && sortOrder === "descend") sortingEnumKey = "-material";

  if (sortField === "purchaser" && sortOrder === "ascend") sortingEnumKey = "purchaser";
  if (sortField === "purchaser" && sortOrder === "descend") sortingEnumKey = "-purchaser";

  if (sortField === "seller" && sortOrder === "ascend") sortingEnumKey = "seller";
  if (sortField === "seller" && sortOrder === "descend") sortingEnumKey = "-seller";

  if (sortField === "total_copy" && sortOrder === "ascend") sortingEnumKey = "total_copy";
  if (sortField === "total_copy" && sortOrder === "descend") sortingEnumKey = "-total_copy";

    return sortingEnumKey;
  };


  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
      sorter: false,
    },
     {
           title: "Serial No",
           dataIndex: "serial_no",
           key: "serial_no",
           render: (text) => text || "N/A",
         },
         {
           title: "Weight For",
           dataIndex: "weight_for",
           key: "weight_for",
           render: (text) => text || "N/A",
         },
         {
           title: "Gross Weight",
           dataIndex: "gross_wt",
           key: "gross_wt",
           render: (text) => text ?? 0,
         },
         {
           title: "Tare Weight",
           dataIndex: "tare_wt",
           key: "tare_wt",
           render: (text) => text ?? 0,
         },
         {
           title: "Net Weight",
           dataIndex: "net_wt",
           key: "net_wt",
           render: (text) => text ?? 0,
         },
         {
           title: "Weight Automatic",
           dataIndex: "weight_automatic",
           key: "weight_automatic",
           render: (text) => (text ? "Yes" : "No"),
         },
         {
           title: "Date & Time",
           dataIndex: "date_time",
           key: "date_time",
           render: (record) => (
             <span>{record ? dayjs(record).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</span>
           ),
         },
         {
           title: "Mound",
           dataIndex: "mound",
           key: "mound",
           render: (text) => text ?? 0,
         },
         {
           title: "Vehicle No.",
           dataIndex: "vehicle_no",
           key: "vehicle_no",
           render: (text) => text || "N/A",
         },
         {
           title: "Vehicle Type",
           dataIndex: "vehicle_type",
           key: "vehicle_type",
           render: (text) => text || "N/A",
         },
         {
           title: "Party Name",
           dataIndex: "party_name",
           key: "party_name",
           render: (text) => text || "N/A",
         },
         {
           title: "Cash Party Name",
           dataIndex: "cash_party_name",
           key: "cash_party_name",
           render: (text) => text || "N/A",
         },
         {
           title: "Party Mobile No",
           dataIndex: "party_mobile_no",
           key: "party_mobile_no",
           render: (text) => text || "N/A",
         },
         {
           title: "Material",
           dataIndex: "material",
           key: "material",
           render: (text) => text || "N/A",
         },
         {
           title: "Purchaser",
           dataIndex: "purchaser",
           key: "purchaser",
           render: (text) => text || "N/A",
         },
         {
           title: "Seller",
           dataIndex: "seller",
           key: "seller",
           render: (text) => text || "N/A",
         },
         {
           title: "Total Copy",
           dataIndex: "total_copy",
           key: "total_copy",
           render: (text) => text ?? 1,
         },
    {
      title: 'Archive At',
      dataIndex: 'archive_at',
      key: 'archive_at',
      width: '100px',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Archive By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      width: '100px',
      sorter: true,
      render: ((record) => {
        return (
          <span>{record ? `${record?.first_name} ${record?.last_name}` : 'N/A'} </span>
        )
      })
    },
    
    {
      title: 'Action',
      width: '100px',
      dataIndex: 'id', // Use `id` here for proper alignment and access
      key: 'action',
      render: (text, record) => (
        <Space>
          <Tooltip placement="top" title={"Unarchive"}>
            <Popconfirm
              title="Are you sure you want to Unarchive this record?"
              onConfirm={() => handleRestore(record?.id)} // Correctly access `id`
              onCancel={() => message.info('Action cancelled')}
              okText="Yes"
              cancelText="No"
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },

  ];

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  return (
    <>
      <div className='sticyaction'>
        <Row className="pagenamerow" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Archived First Weight Entry</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/first-weight-entry-list">First Weight Entry List</Link> },
                  { title: 'Archive First Weight Entry' }
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="large">
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                style={{ width: 200 }}
                onChange={handleSearch}
              />
              <Link>
                <Tooltip placement="top" title={'Reset Filter'}>
                  <Button type="primary" disabled={!search} className='iconlink' onClick={resetFilter}>
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Link>


            </Space>
          </Col>
        </Row>
      </div>
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Table
            rowKey="id"
           // rowSelection={rowSelection}
            dataSource={Array.isArray(data) ? data : []}
            columns={columns}
            pagination={false}
            loading={status === 'loading'}
            onChange={handleTableChange}
             scroll={{
          x: 880, // Horizontal Scroll
          y: 400,  // Vertical Scroll with Fixed Header
        }}
          />
        </div>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            padding: 10,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Pagination
            current={page}
            pageSize={pagesize}
            total={totalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
      </div>
    </>
  );
}
